import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-unpinned",
  "use": "svg_i-unpinned-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg_i-unpinned\"><path d=\"M6.333 9.667 2 14M5.117 5.26l-.652-.068-1.132 1.132 6.129 6.128 1.131-1.131-.068-.654m-2.869-6 2.449-2.886 3.9 3.9-2.872 2.436M3 1l12 12\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol